module.exports = __webpack_public_path__ + "videos/short-preview.4d7ee947232840142cfcdc1528a5c4a7.mp4";


//////////////////
// WEBPACK FOOTER
// ./images/short-preview.mp4
// module id = 310
// module chunks = 0